module.exports = __webpack_public_path__ + "static/media/jongseo-park-portrait.5e570438.png";